export default "__VITE_ASSET__BE0xviOz__"